export default __webpack_public_path__ + "static/media/아로마_mobile.9a1db8c7.jpg";